"use client";
import { useAuthContext } from "lib/hooks";
import { useEffect } from "react";
import { Constants } from "utils/constants";
import { hasRole } from "utils";

export default function HomePage() {
  const { roles } = useAuthContext();

  useEffect(() => {
    // If user has a Response app role, redirect to SitMap. If user only has DecisionScience role, redirect to Decision Science.
    if (hasRole(roles, Constants.AppRoles.allRead)) {
      window.location.replace("/sitmap");
    } else if (hasRole(roles, ["DecisionScience"])) {
      window.location.replace("/decisionscience");
    }
  }, [roles]);
  return null;
}
